import 'webrtc-adapter'

import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'

import App from './App.vue'
import router from './router'
import store from './store'

import VueCompositionApi from "@vue/composition-api"
import {env} from "@/environment"
Vue.use(VueCompositionApi)

Vue.config.productionTip = false

export const eventBus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Sentry.init({
  environment: env.environment,
  dsn: 'https://c9da416df2c2407498a7c8dedbc015a6@o386267.ingest.sentry.io/5220324',
  integrations: [new VueIntegration({Vue, attachProps: true})],
})
